export default __webpack_public_path__ + "static/ai-cold-call-quality-assurance-ffce305d81878f0542721b019792b0fd.png";